var _circle, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOnTrack(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    enableBackground: "new 0 0 50 50",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#5CB981",
    cx: 25,
    cy: 25,
    r: 24.211
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M25.001,9.947c-5.652,0-10.25,4.599-10.25,10.25c0,1.697,0.424,3.379,1.23,4.872l8.459,15.3 c0.113,0.204,0.328,0.33,0.561,0.33s0.448-0.126,0.561-0.33l8.461-15.305c0.803-1.487,1.227-3.169,1.227-4.866 C35.25,14.546,30.652,9.947,25.001,9.947z M25.001,25.323c-2.826,0-5.125-2.299-5.125-5.125c0-2.826,2.3-5.125,5.125-5.125 c2.825,0,5.126,2.299,5.126,5.125C30.127,23.024,27.826,25.323,25.001,25.323z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnTrack);
export default __webpack_public_path__ + "static/media/OnTrack.5b33899e1df17503a58aaeec4d72f46c.svg";
export { ForwardRef as ReactComponent };